(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4910],{

/***/ 893555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ UserProfileColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const UserProfileColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 20 20", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_15571_332)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M10 9.99994C10.9889 9.99994 11.9556 9.7067 12.7779 9.15729C13.6001 8.60788 14.241 7.82699 14.6194 6.91336C14.9978 5.99973 15.0969 4.99439 14.9039 4.02449C14.711 3.05458 14.2348 2.16367 13.5355 1.46441C12.8363 0.765145 11.9454 0.288941 10.9755 0.0960148C10.0055 -0.0969113 9.00021 0.00210539 8.08658 0.380544C7.17295 0.758982 6.39206 1.39984 5.84265 2.22209C5.29324 3.04434 5 4.01103 5 4.99994C5.00132 6.32562 5.52853 7.59662 6.46593 8.53401C7.40332 9.47141 8.67432 9.99862 10 9.99994ZM10 1.66661C10.6593 1.66661 11.3037 1.8621 11.8519 2.22838C12.4001 2.59465 12.8273 3.11524 13.0796 3.72433C13.3319 4.33342 13.3979 5.00364 13.2693 5.65024C13.1407 6.29685 12.8232 6.89079 12.357 7.35696C11.8908 7.82314 11.2969 8.14061 10.6503 8.26923C10.0037 8.39784 9.33348 8.33183 8.72439 8.07954C8.1153 7.82725 7.59471 7.40001 7.22844 6.85184C6.86216 6.30368 6.66667 5.65921 6.66667 4.99994C6.66667 4.11589 7.01786 3.26804 7.64298 2.64292C8.2681 2.0178 9.11595 1.66661 10 1.66661Z",
              fill: "#00973C"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M10 11.6672C8.01155 11.6694 6.10518 12.4603 4.69914 13.8663C3.29309 15.2724 2.50221 17.1787 2.5 19.1672C2.5 19.3882 2.5878 19.6002 2.74408 19.7564C2.90036 19.9127 3.11232 20.0005 3.33333 20.0005C3.55435 20.0005 3.76631 19.9127 3.92259 19.7564C4.07887 19.6002 4.16667 19.3882 4.16667 19.1672C4.16667 17.6201 4.78125 16.1363 5.87521 15.0424C6.96917 13.9484 8.4529 13.3338 10 13.3338C11.5471 13.3338 13.0308 13.9484 14.1248 15.0424C15.2188 16.1363 15.8333 17.6201 15.8333 19.1672C15.8333 19.3882 15.9211 19.6002 16.0774 19.7564C16.2337 19.9127 16.4457 20.0005 16.6667 20.0005C16.8877 20.0005 17.0996 19.9127 17.2559 19.7564C17.4122 19.6002 17.5 19.3882 17.5 19.1672C17.4978 17.1787 16.7069 15.2724 15.3009 13.8663C13.8948 12.4603 11.9884 11.6694 10 11.6672Z",
              fill: "black",
              fillOpacity: "0.88"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_15571_332" },
            child: [
              {
                tag: "rect",
                attr: { width: "20", height: "20", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 240619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ UserProfileFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const UserProfileFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 20 20", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M10 10C12.7614 10 15 7.76142 15 5C15 2.23858 12.7614 0 10 0C7.23858 0 5 2.23858 5 5C5 7.76142 7.23858 10 10 10Z",
          fill: "black",
          fillOpacity: "0.65"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M10 11.6659C5.85977 11.6705 2.50461 15.0257 2.5 19.1659C2.5 19.6261 2.87309 19.9992 3.33332 19.9992H16.6666C17.1269 19.9992 17.5 19.6261 17.5 19.1659C17.4954 15.0257 14.1402 11.6705 10 11.6659Z",
          fill: "black",
          fillOpacity: "0.65"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 139625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Topbar; },
/* harmony export */   "n": function() { return /* binding */ TOPBAR_HEIGHT; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(982226);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);



const TOPBAR_HEIGHT = 42;
const Topbar = ({
  rightMenu = [],
  leftMenu = []
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledContainer, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuWrapper, null, leftMenu.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    key: index
  }, item))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MenuWrapper, null, rightMenu.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    key: index
  }, item)))));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ theme }) => `
  @media print {
    display: none;
  }
  background-color: ${theme == null ? void 0 : theme.colors.primary500};
  height: ${TOPBAR_HEIGHT}px;
`);
const StyledContainer = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W)`
  display: flex;
  justify-content: space-between;
`;
const MenuWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  display: flex;
  .button-text {
    font-weight: 500;
  }
`;




/***/ }),

/***/ 454005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ Badge; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const isNotNullAndUndefined = (num) => {
  return num !== void 0 && num !== null;
};
const StyledBadge = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({
  theme,
  color,
  hidden,
  top,
  right,
  bottom,
  left,
  width,
  height,
  fontSize
}) => `
  display: block;
  position: absolute;
  z-index: 1;
  text-align: center;
  color: ${theme.colors.white};
  border-radius: 50%;
  -webkit-transition-duration: 0.2s;
  transition-duration: 0.2s;
  padding: 0;
  opacity: ${hidden ? "0" : "1"};
  background-color: ${color ? color : theme.brand.primary};
  ${isNotNullAndUndefined(top) ? `top: ${top}px` : ""};
  ${isNotNullAndUndefined(bottom) ? `bottom: ${bottom}px` : ""};
  ${isNotNullAndUndefined(left) ? `left: ${left}px` : ""};
  ${isNotNullAndUndefined(right) ? `right: ${right}px` : ""};
  width: ${isNotNullAndUndefined(width) ? `${width}px` : "16px"};
  height: ${isNotNullAndUndefined(height) ? `${height}px` : "16px"};
  line-height: ${isNotNullAndUndefined(height) ? `${height}px` : "16px"};
  font-size: ${isNotNullAndUndefined(fontSize) ? `${fontSize}px` : "8px"};
`);
const Badge = (_a) => {
  var _b = _a, { text } = _b, rest = __objRest(_b, ["text"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBadge, __spreadValues({}, rest), text);
};




/***/ }),

/***/ 282074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ CartHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(675601);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46610);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(454005);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(891987);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(534090);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(684443);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 8px;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: block;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







const ShoppingCartFilled = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(2067), __webpack_require__.e(99611)]).then(__webpack_require__.bind(__webpack_require__, 102067)).then((mod)=>mod.ShoppingCartFilled), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(102067)
            ]
    }
});
const NewLayoutShoppingCartOutlined = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(2067), __webpack_require__.e(99611)]).then(__webpack_require__.bind(__webpack_require__, 102067)).then((mod)=>mod.NewLayoutShoppingCartOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(102067)
            ]
    }
});
const IconCart = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .styled */ .z)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__/* .TekoLink */ .A)(_templateObject());
const StyledIcon = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .SvgIcon */ .l)(_templateObject1());
const CartHeader = (_param)=>{
    var { iconSize =20 , iconColor , badgeTop =0 , badgeRight =0 , badgeWidth =16 , clickCart , type ="outlined"  } = _param, rest = _objectWithoutProperties(_param, [
        "iconSize",
        "iconColor",
        "badgeTop",
        "badgeRight",
        "badgeWidth",
        "clickCart",
        "type"
    ]);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { totalCartItems  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_7__/* .useCartV2 */ .T6)();
    const { displayNewLayout , epicOmni1643  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_8__/* .useTenantConfig */ .Wx)();
    const isDisplayNewLayout = displayNewLayout || epicOmni1643;
    const clickToCart = clickCart ? clickCart : ()=>{
        router.push("/cart").then(()=>window.scrollTo(0, 0));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(IconCart, _objectSpreadProps(_objectSpread({}, rest), {
        onClick: (e)=>{
            e.preventDefault();
            clickToCart();
        },
        href: "/cart",
        children: [
            type === "outlined" ? isDisplayNewLayout ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NewLayoutShoppingCartOutlined, {
                size: iconSize,
                color: iconColor
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledIcon, {
                name: "shopping-cart",
                size: iconSize,
                color: iconColor
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ShoppingCartFilled, {
                size: iconSize,
                color: iconColor
            }),
            totalCartItems > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_9__/* .Badge */ .C, {
                className: "cart-badge",
                width: badgeWidth,
                text: "".concat(totalCartItems),
                top: badgeTop,
                right: badgeRight
            })
        ]
    }));
};


/***/ }),

/***/ 543427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ HeaderIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(684443);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(428247);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _CartHeader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(282074);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 0;\n  .cart-badge {\n    background-color: white;\n    color: black;\n    line-height: 12px;\n    height: 12px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







const FacebookMessengerFilled = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(2067), __webpack_require__.e(99611)]).then(__webpack_require__.bind(__webpack_require__, 102067)).then((mod)=>mod.FacebookMessengerFilled), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(102067)
            ]
    }
});
const ZaloFilled = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(2067), __webpack_require__.e(99611)]).then(__webpack_require__.bind(__webpack_require__, 102067)).then((mod)=>mod.ZaloFilled), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(102067)
            ]
    }
});
const Wrapper = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__["default"].div((param)=>{
    let { isVisible , transitionDelay , theme  } = param;
    return "\n    max-width: ".concat(isVisible ? "180px" : "0px", ";\n    display: ").concat(isVisible ? "flex" : "none", ";\n    transition: max-width 0.2s ").concat(isVisible ? "ease-in" : "ease-out", ";\n    transition-delay: ").concat(isVisible ? transitionDelay : "0s", ";\n    overflow: hidden;\n    align-items: center;\n    column-gap: ").concat(theme.spacing.s12, ";\n    flex: 0 0 auto;\n  ");
});
const Anchor = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__["default"].a(_templateObject());
const IconWrapper = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__["default"].div(_templateObject1());
const HeaderIcon = (param)=>{
    let { isVisible =true , transitionDelay ="0s" , isDisplayContact =true , isShowCartIcon =false  } = param;
    const { contactLink , isDisplayMessenger , zaloContactLink , displayNewLayout  } = (0,_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useTenantConfig */ .Wx)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
            isVisible: isVisible,
            transitionDelay: transitionDelay,
            children: [
                isDisplayContact && contactLink && isDisplayMessenger && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Anchor, {
                    href: contactLink,
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapper, _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
                        isTrackContent: true,
                        regionName: "quickAction",
                        contentName: "fbMessengerIcon"
                    })), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FacebookMessengerFilled, {
                            size: 30,
                            color: "#fff"
                        })
                    }))
                }),
                zaloContactLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Anchor, {
                    href: zaloContactLink,
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapper, _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
                        isTrackContent: true,
                        regionName: "quickAction",
                        contentName: "zaloMessengerIcon"
                    })), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ZaloFilled, {
                            size: 24,
                            color: "#fff"
                        })
                    }))
                }),
                isShowCartIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CartIcon, {
                    iconSize: 24,
                    badgeWidth: 12,
                    badgeTop: 0,
                    iconColor: "#fff",
                    type: displayNewLayout ? "outlined" : "filled"
                })
            ]
        })
    });
};
const CartIcon = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__["default"])(_CartHeader__WEBPACK_IMPORTED_MODULE_6__/* .CartHeader */ .Q)(_templateObject2());


/***/ }),

/***/ 265987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HeaderRightItemSlot": function() { return /* binding */ HeaderRightItemSlot; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ./components/mobile/organisms/HeaderIcon.tsx
var HeaderIcon = __webpack_require__(543427);
;// CONCATENATED MODULE: ./modules/page-builder/slots/header-right-item/HeaderRightItemMobile.tsx


const HeaderRightItemMobile = (param)=>{
    let {} = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderIcon/* HeaderIcon */.N, {
        isVisible: true,
        isShowCartIcon: true
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/context.es.js + 1 modules
var context_es = __webpack_require__(983546);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/LocationPickerColored.es.js
var LocationPickerColored_es = __webpack_require__(650896);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/DownOutlined.es.js
var DownOutlined_es = __webpack_require__(925810);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
// EXTERNAL MODULE: ./components/RegionPickerSuggestionPopover/RegionPickerSuggestionPopover.tsx
var RegionPickerSuggestionPopover = __webpack_require__(996199);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Skeleton/Skeleton.es.js
var Skeleton_es = __webpack_require__(134128);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/components/Dropdown/Dropdown.es.js
var Dropdown_es = __webpack_require__(635412);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(618428);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/hook.es.js
var hook_es = __webpack_require__(339674);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Image/Image.es.js
var Image_es = __webpack_require__(587021);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/components/ListContent/ListContent.es.js
var ListContent_es = __webpack_require__(691568);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/AnonymousUserProfileOutlined.es.js
var AnonymousUserProfileOutlined_es = __webpack_require__(71856);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/UserProfileColored.es.js
var UserProfileColored_es = __webpack_require__(893555);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/UserProfileFilled.es.js
var UserProfileFilled_es = __webpack_require__(240619);
// EXTERNAL MODULE: ./contexts/ServiceContext.tsx
var ServiceContext = __webpack_require__(643015);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./helpers/teko-oauth.ts
var teko_oauth = __webpack_require__(118042);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./components/desktop/organisms/style.ts
var style = __webpack_require__(60862);
;// CONCATENATED MODULE: ./components/desktop/organisms/UserProfileHeaderV2.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  height: 2rem;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  .name {\n    font-size: 14px;\n    line-height: 22px;\n    font-weight: 500;\n  }\n  .extra {\n    font-size: 12px;\n    line-height: 20px;\n    font-weight: 400;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  z-index: 100;\n  display: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










const UserProfileHeaderV2 = (param)=>{
    let { profileLinks  } = param;
    const { 0: show , 1: setShow  } = (0,react.useState)(false);
    const { user: userProfile , loading: profileLoading , authService  } = (0,context_es/* useAuth */.aC)();
    const onLogin = ()=>authService.login();
    if (profileLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_es/* Skeleton */.O, {
        height: "0.75rem",
        width: "90px"
    });
    if (!(userProfile === null || userProfile === void 0 ? void 0 : userProfile.userId)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown_es/* Dropdown */.L, {
            placement: "bottom-start",
            menu: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                style: {
                    cursor: "pointer"
                },
                onClick: onLogin,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                    color: "white",
                    children: (0,i18n.t)("Đăng k\xfd/Đăng nhập")
                })
            }),
            backgroundColor: "textPrimary",
            width: "max-content",
            padding: [
                "s4",
                "s8"
            ],
            borderRadius: "m",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* NavigationIconButton */.C, _objectSpreadProps(_objectSpread({
                onClick: onLogin,
                className: "button"
            }, (0,helper_es/* getTrackingData */.O5)({
                isTrackContent: true,
                regionName: "headerBar",
                contentName: "loginIcon"
            })), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnonymousUserProfileOutlined_es/* AnonymousUserProfileOutlined */.u, {
                    size: 20
                })
            }))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
        style: {
            position: "relative"
        },
        onMouseEnter: ()=>setShow(true),
        onMouseLeave: ()=>setShow(false),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                href: "/account",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* NavigationIconButton */.C, _objectSpreadProps(_objectSpread({
                    className: "button"
                }, (0,helper_es/* getTrackingData */.O5)({
                    isTrackContent: true,
                    regionName: "headerBar",
                    contentName: "profileIcon"
                })), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfileColored_es/* UserProfileColored */.G, {
                        size: 20
                    })
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfileMenuWrapper, {
                style: {
                    position: "absolute",
                    transition: "display 0.3s"
                },
                padding: "s4",
                borderRadius: "m",
                show: show,
                backgroundColor: "white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfileMenu, {
                    profileLinks: profileLinks,
                    userProfile: userProfile
                })
            })
        ]
    });
};
const UserProfileMenu = (param)=>{
    let { profileLinks , userProfile  } = param;
    const { showModal  } = (0,hook_es/* useModal */.d)();
    const { authService  } = (0,context_es/* useAuth */.aC)();
    const { notificationService  } = (0,ServiceContext/* useServices */.Su)();
    const { notificationAppId  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
        width: "240px",
        borderRadius: "s",
        padding: [
            "s12",
            "s4"
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                padding: "s16",
                gap: "s12",
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                        height: "36px",
                        width: "36px",
                        align: "center",
                        justify: "center",
                        backgroundColor: "tableHeader",
                        style: {
                            borderRadius: "calc(infinity * 1px)"
                        },
                        children: userProfile.avatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_es/* Image */.E, {
                            src: userProfile.avatar,
                            borderRadius: "calc(infinity * 1px)",
                            alt: "Avatar"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfileFilled_es/* UserProfileFilled */.x, {
                            size: 20,
                            color: "textSecondary"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserInfo, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "name",
                                children: userProfile.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: "extra",
                                children: userProfile.email || userProfile.telephone
                            })
                        ]
                    })
                ]
            }),
            profileLinks && profileLinks.map((profileLink)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileLink, {
                    icon: profileLink.icon,
                    href: profileLink.href,
                    text: profileLink.text,
                    contentName: profileLink.contentName,
                    regionName: profileLink.regionName
                }, profileLink.href)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, _objectSpreadProps(_objectSpread({
                padding: "s8"
            }, (0,helper_es/* getTrackingData */.O5)({
                isTrackContent: true,
                regionName: "headerBar",
                contentName: "logOut"
            })), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                    onClick: ()=>{
                        showModal === null || showModal === void 0 ? void 0 : showModal({
                            title: (0,i18n.t)("Đăng xuất"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: (0,i18n.t)("Bạn c\xf3 chắc chắn muốn đăng xuất kh\xf4ng?")
                            }),
                            onOk: ()=>(0,teko_oauth/* onSignOut */.U)(authService, notificationService, notificationAppId, window.location.origin),
                            cancelText: (0,i18n.t)("Kh\xf4ng"),
                            okText: (0,i18n.t)("C\xf3")
                        });
                    },
                    variant: "primary",
                    children: (0,i18n.t)("Đăng xuất")
                })
            }))
        ]
    });
};
const ProfileLink = (param)=>{
    let { icon , text , href , regionName , contentName , onClick  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListContent_es/* ListContent */.y, _objectSpread({
            padding: [
                "s8",
                "s8"
            ],
            icon: icon,
            label: text,
            onClick: onClick
        }, (0,helper_es/* getTrackingData */.O5)({
            isTrackContent: true,
            regionName,
            contentName
        })))
    });
};
const StyledButton = (0,emotion_styled_browser_esm["default"])(Button_es/* Button */.z)(_templateObject());
const UserInfo = (0,emotion_styled_browser_esm["default"])(index_es/* Shape */.b)(_templateObject1());
const UserProfileMenuWrapper = (0,emotion_styled_browser_esm["default"])(index_es/* Shape */.b)(_templateObject2(), (props)=>props.show ? "block" : "none");

// EXTERNAL MODULE: ./components/desktop/organisms/PopupRegionPicker.tsx
var PopupRegionPicker = __webpack_require__(761035);
// EXTERNAL MODULE: ./contexts/FeatureFlagProvider.tsx + 1 modules
var FeatureFlagProvider = __webpack_require__(723357);
// EXTERNAL MODULE: ./contexts/LocationProvider.tsx
var LocationProvider = __webpack_require__(158610);
// EXTERNAL MODULE: ./contexts/ThreeLevelLocationProvider/index.tsx + 8 modules
var ThreeLevelLocationProvider = __webpack_require__(779454);
// EXTERNAL MODULE: ./helpers/navigation-bar.tsx
var navigation_bar = __webpack_require__(382934);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(788813);
// EXTERNAL MODULE: ./hooks/useLoyaltyMemberInfo.ts
var useLoyaltyMemberInfo = __webpack_require__(401192);
// EXTERNAL MODULE: ./hooks/useRegionPicker.tsx
var useRegionPicker = __webpack_require__(642816);
// EXTERNAL MODULE: ./modules/cart/desktop/CartOverview.tsx
var CartOverview = __webpack_require__(236549);
// EXTERNAL MODULE: ./modules/notification/desktop/NotificationOverview.tsx
var NotificationOverview = __webpack_require__(268905);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Dropdown/DropdownToggle.es.js
var DropdownToggle_es = __webpack_require__(437753);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Dropdown/DropdownMenu.es.js
var DropdownMenu_es = __webpack_require__(332762);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/molecules/Dropdown/Dropdown.es.js
var Dropdown_Dropdown_es = __webpack_require__(929556);
// EXTERNAL MODULE: ./contexts/DistanceTerminalProvider/index.tsx + 11 modules
var DistanceTerminalProvider = __webpack_require__(385365);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./tenants/_template/desktop/_module/components/NavigationBar.tsx + 2 modules
var NavigationBar = __webpack_require__(836816);
;// CONCATENATED MODULE: ./modules/terminal/desktop/TerminalOverview.tsx
function TerminalOverview_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function TerminalOverview_templateObject() {
    const data = TerminalOverview_taggedTemplateLiteral([
        "\n  width: auto;\n  position: relative;\n"
    ]);
    TerminalOverview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









const MiniTerminalPicker = dynamic_default()(()=>__webpack_require__.e(/* import() */ 38450).then(__webpack_require__.bind(__webpack_require__, 238450)).then((mod)=>mod.MiniTerminalPicker), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(238450)
            ]
    }
});
const TerminalOverview = ()=>{
    const { currentTerminal  } = (0,DistanceTerminalProvider/* useDistanceTerminalContext */.d)();
    const { 0: miniCartOpen , 1: setMiniCartOpen  } = (0,react.useState)(false);
    const toggleMiniCart = (0,react.useCallback)(()=>{
        setMiniCartOpen(!miniCartOpen);
    }, [
        miniCartOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDropdown, {
        isOpen: miniCartOpen,
        toggle: toggleMiniCart,
        toggleType: "hover",
        onHide: ()=>setMiniCartOpen(false),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownToggle_es/* DropdownToggle */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavigationBar/* NavItem */.LY, {
                    className: "att-home-page-delivery-area",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationPickerColored_es/* LocationPickerColored */.B, {
                            size: 20
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Caption */.YS, {
                                    color: "textSecondary",
                                    children: (0,i18n.t)("Xem sản phẩm tại")
                                }),
                                !!(currentTerminal === null || currentTerminal === void 0 ? void 0 : currentTerminal.terminalName) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                    level: 2,
                                    weight: "medium",
                                    maxWidth: "128px",
                                    line: 1,
                                    children: currentTerminal === null || currentTerminal === void 0 ? void 0 : currentTerminal.terminalName
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                    level: 2,
                                    weight: "medium",
                                    children: (0,i18n.t)("Chưa c\xf3 si\xeau thị được chọn")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined_es/* DownOutlined */.T, {
                            size: 20
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenu_es/* DropdownMenu */.h, {
                popperConfig: {
                    placement: "top-end"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniTerminalPicker, {})
            })
        ]
    });
};
const StyledDropdown = (0,emotion_styled_browser_esm["default"])(Dropdown_Dropdown_es/* Dropdown */.L)(TerminalOverview_templateObject());

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/LocationOutlined.es.js
var LocationOutlined_es = __webpack_require__(402374);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/OrderOutlined.es.js
var OrderOutlined_es = __webpack_require__(883594);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/ChecklistOutlined.es.js
var ChecklistOutlined_es = __webpack_require__(383497);
// EXTERNAL MODULE: ./components/desktop/organisms/UserProfileHeader.tsx
var UserProfileHeader = __webpack_require__(583880);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
;// CONCATENATED MODULE: ./modules/page-builder/slots/header-right-item/HeaderRightItemDesktop.tsx
function HeaderRightItemDesktop_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function HeaderRightItemDesktop_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HeaderRightItemDesktop_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function HeaderRightItemDesktop_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function HeaderRightItemDesktop_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        HeaderRightItemDesktop_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

















const HeaderRightItemDesktop = (param)=>{
    let {} = param;
    const {} = (0,next_router.useRouter)();
    const { partner , tenant , isDmsFlow , epicOmni1541 , notificationAppId , epicOmni1538 , notFetchLoyaltyMemberInfoGlobally , displayNewLayout ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { user , authService  } = (0,context_es/* useAuth */.aC)();
    const { loyaltyMemberInfo  } = (0,useLoyaltyMemberInfo/* useLoyaltyMemberInfo */.h)(!notFetchLoyaltyMemberInfoGlobally);
    const { flags  } = (0,FeatureFlagProvider/* useFeatureFlags */.g)();
    const regionPickerProps = (0,useRegionPicker/* useRegionPicker */.j)();
    const region = regionPickerProps === null || regionPickerProps === void 0 ? void 0 : regionPickerProps.activeLocation;
    const { setShowed: showLocationPopup , selectedLocation , showRegionPickerSuggestionPopover , onCloseRegionPickerSuggestionPopover , enabled: locationPickerEnabled ,  } = (0,LocationProvider/* useLocation */.T)();
    const { correctThreeLevelLocation , onOpenThreeLevelLocationPopup  } = (0,ThreeLevelLocationProvider/* useThreeLevelLocationContext */.u0)();
    const onLogin = ()=>authService.login(window.location.href);
    const router = (0,next_router.useRouter)();
    const profileLinks = (0,react.useMemo)(()=>{
        return (0,navigation_bar/* getNavItems */.r)({
            tenant,
            logged: !!(user === null || user === void 0 ? void 0 : user.userId),
            showLoyaltyItem: (notFetchLoyaltyMemberInfoGlobally ? !!(user === null || user === void 0 ? void 0 : user.loyaltyMemberId) : !!loyaltyMemberInfo) || !!epicOmni1538,
            showNotificationItem: !!notificationAppId,
            epicOmni1546: true,
            displayNewLayout: displayNewLayout
        });
    }, [
        tenant,
        user,
        loyaltyMemberInfo
    ]);
    const RegionPickerIcon = (param)=>{
        let { locationName  } = param;
        const showRegionPickerModal = ()=>{
            if (flags.epic_ecom_284) {
                showLocationPopup(true);
            } else {
                regionPickerProps.onOpenPopup();
            }
        };
        // Don't show this icon on the server side
        if (!(0,helpers/* isServerless */.ep)()) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPickerSuggestionPopover/* RegionPickerSuggestionPopover */.R, {
            active: showRegionPickerSuggestionPopover,
            onClose: onCloseRegionPickerSuggestionPopover,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavigationBar/* NavItem */.LY, HeaderRightItemDesktop_objectSpreadProps(HeaderRightItemDesktop_objectSpread({
                onClick: showRegionPickerModal
            }, (0,helper_es/* getTrackingData */.O5)({
                isTrackContent: true,
                regionName: "headerBar",
                contentName: "location"
            })), {
                className: "att-home-page-delivery-area",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOutlined_es/* LocationOutlined */.f, {
                        size: 36,
                        color: "textSecondary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Caption */.YS, {
                                color: "textSecondary",
                                children: (0,i18n.t)("Xem sản phẩm tại")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                maxWidth: "128px",
                                line: 1,
                                level: 2,
                                weight: "medium",
                                color: "textSecondary",
                                children: locationName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined_es/* DownOutlined */.T, {
                        size: 24,
                        color: "textSecondary"
                    })
                ]
            }))
        });
    };
    const ThreeLevelLocationPickerIcon = ()=>{
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPickerSuggestionPopover/* RegionPickerSuggestionPopover */.R, {
            active: !!showRegionPickerSuggestionPopover,
            onClose: onCloseRegionPickerSuggestionPopover !== null && onCloseRegionPickerSuggestionPopover !== void 0 ? onCloseRegionPickerSuggestionPopover : ()=>{},
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavigationBar/* NavItem */.LY, {
                onClick: onOpenThreeLevelLocationPopup,
                className: "att-home-page-delivery-area",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOutlined_es/* LocationOutlined */.f, {
                        size: 36,
                        color: "textSecondary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Caption */.YS, {
                                color: "textSecondary",
                                children: (0,i18n.t)("Xem sản phẩm tại")
                            }),
                            !!correctThreeLevelLocation ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Body */.uT, {
                                level: 2,
                                weight: "medium",
                                color: "textSecondary",
                                maxWidth: "128px",
                                line: 1,
                                children: [
                                    correctThreeLevelLocation.ward.label,
                                    ",",
                                    " ",
                                    (ref = correctThreeLevelLocation.district) === null || ref === void 0 ? void 0 : ref.label,
                                    ",",
                                    " ",
                                    correctThreeLevelLocation.province.label
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                level: 2,
                                weight: "medium",
                                color: "textSecondary",
                                children: (0,i18n.t)("Chưa c\xf3 địa chỉ được chọn")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined_es/* DownOutlined */.T, {
                        size: 24,
                        color: "textSecondary"
                    })
                ]
            })
        });
    };
    const navItems = (0,react.useMemo)(()=>{
        var ref;
        const { order , login , cart , additional  } = NavigationBar/* defaultNavItemDisplayConfig */.dn;
        const navMenu = [];
        if (order) navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, HeaderRightItemDesktop_objectSpreadProps(HeaderRightItemDesktop_objectSpread({
            className: "button",
            onClick: ()=>{
                if (!(user === null || user === void 0 ? void 0 : user.userId)) {
                    onLogin();
                } else {
                    router.push("/account/orders");
                }
            },
            style: (0,NavigationBar/* isVerticalNavItem */.fi)(tenant) ? {
                flexDirection: "column"
            } : {
                flexDirection: "row"
            }
        }, (0,helper_es/* getTrackingData */.O5)({
            isTrackContent: true,
            regionName: "headerBar",
            contentName: "orderIcon"
        })), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderOutlined_es/* OrderOutlined */.y, {
                    size: 36,
                    color: "textSecondary"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "title",
                    children: (0,i18n.t)("Đơn h\xe0ng")
                })
            ]
        })));
        if (login) navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfileHeader/* UserProfileHeader */.F, {
            vertical: (0,NavigationBar/* isVerticalNavItem */.fi)(tenant),
            customProfile: !!partner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                href: "/account/orders",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, {
                    className: "button",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChecklistOutlined_es/* ChecklistOutlined */.H, {
                            size: 36,
                            color: "textSecondary"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: (0,i18n.t)("Quản l\xfd đơn h\xe0ng")
                        })
                    ]
                })
            }) : undefined,
            profileLinks: profileLinks
        }));
        if (notificationAppId) navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationOverview/* NotificationOverview */.C, {
            title: (0,NavigationBar/* isVerticalNavItem */.fi)(tenant)
        }));
        if (cart) navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(CartOverview/* CartOverview */.T, {
            showShippingFeeMiniCart: true,
            vertical: (0,NavigationBar/* isVerticalNavItem */.fi)(tenant)
        }));
        if (locationPickerEnabled) {
            navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPickerIcon, {
                locationName: selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.locationName
            }));
        } else if ((regionPickerProps === null || regionPickerProps === void 0 ? void 0 : regionPickerProps.isShowLocationIcon) && region && (regionPickerProps === null || regionPickerProps === void 0 ? void 0 : (ref = regionPickerProps.terminals) === null || ref === void 0 ? void 0 : ref.length) > 1) {
            navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPickerIcon, {
                locationName: region === null || region === void 0 ? void 0 : region.label
            }));
        }
        if (additional) navMenu.push(additional);
        if (!isDmsFlow && !!epicOmni1541) {
            navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(ThreeLevelLocationPickerIcon, {}));
        }
        return navMenu;
    }, [
        epicOmni1541,
        isDmsFlow,
        locationPickerEnabled,
        notificationAppId,
        partner,
        profileLinks,
        region,
        selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.locationName,
        tenant,
        user === null || user === void 0 ? void 0 : user.userId,
        correctThreeLevelLocation, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
        flexWrap: "nowrap",
        gap: "s16",
        align: "center",
        justify: "end",
        children: [
            navItems.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                    children: item
                }, index)),
            !(flags === null || flags === void 0 ? void 0 : flags.epic_ecom_284) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupRegionPicker/* PopupRegionPicker */.H, HeaderRightItemDesktop_objectSpread({}, regionPickerProps))
        ]
    });
};

;// CONCATENATED MODULE: ./modules/page-builder/slots/header-right-item/HeaderRightItemDesktopV2.tsx
function HeaderRightItemDesktopV2_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function HeaderRightItemDesktopV2_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HeaderRightItemDesktopV2_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function HeaderRightItemDesktopV2_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function HeaderRightItemDesktopV2_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        HeaderRightItemDesktopV2_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

















const NewLayoutHeaderRightItemDesktop = (param)=>{
    let {} = param;
    const { partner , tenant , isDmsFlow , epicOmni1541 , epicOmni1584Phase2 , notificationAppId , epicOmni1538 , notFetchLoyaltyMemberInfoGlobally , displayNewLayout ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { user  } = (0,context_es/* useAuth */.aC)();
    const { loyaltyMemberInfo  } = (0,useLoyaltyMemberInfo/* useLoyaltyMemberInfo */.h)(!notFetchLoyaltyMemberInfoGlobally);
    const { flags  } = (0,FeatureFlagProvider/* useFeatureFlags */.g)();
    const regionPickerProps = (0,useRegionPicker/* useRegionPicker */.j)();
    const region = regionPickerProps === null || regionPickerProps === void 0 ? void 0 : regionPickerProps.activeLocation;
    const { setShowed: showLocationPopup , selectedLocation , showRegionPickerSuggestionPopover , onCloseRegionPickerSuggestionPopover , enabled: locationPickerEnabled ,  } = (0,LocationProvider/* useLocation */.T)();
    const { correctThreeLevelLocation , onOpenThreeLevelLocationPopup  } = (0,ThreeLevelLocationProvider/* useThreeLevelLocationContext */.u0)();
    const profileLinks = (0,react.useMemo)(()=>{
        return (0,navigation_bar/* getNavItems */.r)({
            tenant,
            logged: !!(user === null || user === void 0 ? void 0 : user.userId),
            showLoyaltyItem: (notFetchLoyaltyMemberInfoGlobally ? !!(user === null || user === void 0 ? void 0 : user.loyaltyMemberId) : !!loyaltyMemberInfo) || !!epicOmni1538,
            showNotificationItem: !!notificationAppId,
            epicOmni1546: true,
            displayNewLayout: displayNewLayout
        });
    }, [
        tenant,
        user,
        loyaltyMemberInfo
    ]);
    const RegionPickerIcon = (param)=>{
        let { locationName  } = param;
        const showRegionPickerModal = ()=>{
            if (flags.epic_ecom_284) {
                showLocationPopup(true);
            } else {
                regionPickerProps.onOpenPopup();
            }
        };
        // Don't show this icon on the server side
        if (!(0,helpers/* isServerless */.ep)()) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPickerSuggestionPopover/* RegionPickerSuggestionPopover */.R, {
            active: showRegionPickerSuggestionPopover,
            onClose: onCloseRegionPickerSuggestionPopover,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavigationBar/* NavItem */.LY, HeaderRightItemDesktopV2_objectSpreadProps(HeaderRightItemDesktopV2_objectSpread({
                onClick: showRegionPickerModal
            }, (0,helper_es/* getTrackingData */.O5)({
                isTrackContent: true,
                regionName: "headerBar",
                contentName: "location"
            })), {
                className: "att-home-page-delivery-area",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationPickerColored_es/* LocationPickerColored */.B, {
                        size: 20
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Caption */.YS, {
                                color: "textSecondary",
                                children: (0,i18n.t)("Xem sản phẩm tại")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                maxWidth: "128px",
                                line: 1,
                                level: 2,
                                weight: "medium",
                                children: locationName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined_es/* DownOutlined */.T, {
                        size: 20
                    })
                ]
            }))
        });
    };
    const ThreeLevelLocationPickerIcon = ()=>{
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPickerSuggestionPopover/* RegionPickerSuggestionPopover */.R, {
            active: !!showRegionPickerSuggestionPopover,
            onClose: onCloseRegionPickerSuggestionPopover !== null && onCloseRegionPickerSuggestionPopover !== void 0 ? onCloseRegionPickerSuggestionPopover : ()=>{},
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavigationBar/* NavItem */.LY, {
                onClick: onOpenThreeLevelLocationPopup,
                className: "att-home-page-delivery-area",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationPickerColored_es/* LocationPickerColored */.B, {
                        size: 20
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Caption */.YS, {
                                color: "textSecondary",
                                children: (0,i18n.t)("Xem sản phẩm tại")
                            }),
                            !!correctThreeLevelLocation ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Body */.uT, {
                                level: 2,
                                weight: "medium",
                                maxWidth: "128px",
                                line: 1,
                                children: [
                                    correctThreeLevelLocation.ward.label,
                                    ",",
                                    " ",
                                    (ref = correctThreeLevelLocation.district) === null || ref === void 0 ? void 0 : ref.label,
                                    ",",
                                    " ",
                                    correctThreeLevelLocation.province.label
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                level: 2,
                                weight: "medium",
                                children: (0,i18n.t)("Chưa c\xf3 địa chỉ được chọn")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined_es/* DownOutlined */.T, {
                        size: 20
                    })
                ]
            })
        });
    };
    const locationPicker = ()=>{
        var ref;
        if (locationPickerEnabled) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPickerIcon, {
                locationName: selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.locationName
            });
        } else if ((regionPickerProps === null || regionPickerProps === void 0 ? void 0 : regionPickerProps.isShowLocationIcon) && region && (regionPickerProps === null || regionPickerProps === void 0 ? void 0 : (ref = regionPickerProps.terminals) === null || ref === void 0 ? void 0 : ref.length) > 1) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPickerIcon, {
                locationName: region === null || region === void 0 ? void 0 : region.label
            });
        }
        if (!isDmsFlow && !!epicOmni1541) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreeLevelLocationPickerIcon, {});
        }
        if (!isDmsFlow && !!epicOmni1584Phase2) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TerminalOverview, {});
        }
    };
    const navItems = (0,react.useMemo)(()=>{
        const { login , cart , additional  } = NavigationBar/* defaultNavItemDisplayConfig */.dn;
        const navMenu = [];
        if (login) navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfileHeaderV2, {
            profileLinks: profileLinks
        }));
        if (notificationAppId) navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationOverview/* NotificationOverview */.C, {}));
        if (cart) navMenu.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(CartOverview/* CartOverview */.T, {
            showShippingFeeMiniCart: true
        }));
        if (additional) navMenu.push(additional);
        return navMenu;
    }, [
        epicOmni1541,
        isDmsFlow,
        locationPickerEnabled,
        notificationAppId,
        partner,
        profileLinks,
        region,
        selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.locationName,
        tenant,
        user === null || user === void 0 ? void 0 : user.userId,
        correctThreeLevelLocation, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
        flexWrap: "nowrap",
        gap: "s20",
        align: "center",
        justify: "end",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                flexWrap: "nowrap",
                gap: "s24",
                align: "center",
                justify: "end",
                borderRight: "1px solid divider",
                paddingRight: "s20",
                children: navItems.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                        children: item
                    }, index))
            }),
            locationPicker(),
            !(flags === null || flags === void 0 ? void 0 : flags.epic_ecom_284) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupRegionPicker/* PopupRegionPicker */.H, HeaderRightItemDesktopV2_objectSpread({}, regionPickerProps))
        ]
    });
};
const HeaderRightItemDesktopV2_HeaderRightItemDesktop = (param)=>{
    let {} = param;
    const { displayNewLayout  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    return displayNewLayout ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NewLayoutHeaderRightItemDesktop, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderRightItemDesktop, {});
};

;// CONCATENATED MODULE: ./modules/page-builder/slots/header-right-item/index.ts


const HeaderRightItemSlot = {
    desktop: HeaderRightItemDesktopV2_HeaderRightItemDesktop,
    mobile: HeaderRightItemMobile
};


/***/ }),

/***/ 321708:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={815:function(e){function hasOwnProperty(e,r){return Object.prototype.hasOwnProperty.call(e,r)}e.exports=function(e,n,t,o){n=n||"&";t=t||"=";var a={};if(typeof e!=="string"||e.length===0){return a}var i=/\+/g;e=e.split(n);var u=1e3;if(o&&typeof o.maxKeys==="number"){u=o.maxKeys}var c=e.length;if(u>0&&c>u){c=u}for(var p=0;p<c;++p){var f=e[p].replace(i,"%20"),s=f.indexOf(t),_,l,y,d;if(s>=0){_=f.substr(0,s);l=f.substr(s+1)}else{_=f;l=""}y=decodeURIComponent(_);d=decodeURIComponent(l);if(!hasOwnProperty(a,y)){a[y]=d}else if(r(a[y])){a[y].push(d)}else{a[y]=[a[y],d]}}return a};var r=Array.isArray||function(e){return Object.prototype.toString.call(e)==="[object Array]"}},577:function(e){var stringifyPrimitive=function(e){switch(typeof e){case"string":return e;case"boolean":return e?"true":"false";case"number":return isFinite(e)?e:"";default:return""}};e.exports=function(e,t,o,a){t=t||"&";o=o||"=";if(e===null){e=undefined}if(typeof e==="object"){return map(n(e),(function(n){var a=encodeURIComponent(stringifyPrimitive(n))+o;if(r(e[n])){return map(e[n],(function(e){return a+encodeURIComponent(stringifyPrimitive(e))})).join(t)}else{return a+encodeURIComponent(stringifyPrimitive(e[n]))}})).join(t)}if(!a)return"";return encodeURIComponent(stringifyPrimitive(a))+o+encodeURIComponent(stringifyPrimitive(e))};var r=Array.isArray||function(e){return Object.prototype.toString.call(e)==="[object Array]"};function map(e,r){if(e.map)return e.map(r);var n=[];for(var t=0;t<e.length;t++){n.push(r(e[t],t))}return n}var n=Object.keys||function(e){var r=[];for(var n in e){if(Object.prototype.hasOwnProperty.call(e,n))r.push(n)}return r}}};var r={};function __nccwpck_require__(n){var t=r[n];if(t!==undefined){return t.exports}var o=r[n]={exports:{}};var a=true;try{e[n](o,o.exports,__nccwpck_require__);a=false}finally{if(a)delete r[n]}return o.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var n={};!function(){var e=n;e.decode=e.parse=__nccwpck_require__(815);e.encode=e.stringify=__nccwpck_require__(577)}();module.exports=n})();

/***/ })

}]);